import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";
import { handleDeleteItem } from "./HandleDeleteFunction";
import { handleClose } from "./HandleClosePop/handleclose";
import { setReportsDatas } from "../../Slices/employeeslice";
import { SelectInput } from "../../blueplanitUtils/InputField";
import Modal from "../../blueplanitUtils/Modal";
import { useFormHandler } from "../../blueplanitUtils/EmployeeSubmitFun";
import {ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT, DIRECT_REPORTS, TEAM_TYPE} from "../../Dropdownmanager";
import { getOptionsByPath, useNestedDropdownHandler } from "../../utilsdata";

export const ReportModelpopUp = () => {
    const { handleSubmit } = useFormHandler()
    const dispatch = useDispatch()
    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);

    const Departmentoptions = getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT]);
    const { selectedId, selectedValue, handleChange } = useNestedDropdownHandler(Departmentoptions, "department");
    const Reportsup = useSelector((state) => state.employee.reportsDatas);
    const [reportsData, setReportsData] = useState([]);
    const [isDirectReportFormValid, setIsDirectReportFormValid] = useState(false);
    const [reportErrors, setDirectReportErrors] = useState({});
    const AllEmployees = useSelector((state) => state.employee.AllEmployees);

    const validateReportField = (reports) => {
        const errors = {};
        const alphaRegex = /^[A-Za-z\s-]+$/; // Regex for letters, spaces, and hyphens only

        reports.forEach((report, index) => {
            const reportErrors = {};

            if (!report.DirectReportName?.trim()) {
                reportErrors.DirectReportName = "Direct Report Name is required.";
            }


            if (!report.DirectReportType?.trim()) {
                reportErrors.DirectReportType = "Direct Report Type is required.";
            } else if (!alphaRegex.test(report.DirectReportType)) {
                reportErrors.DirectReportType = "Direct Report Type must contain only letters.";
            }

            if (!report.DirectReportDesignation) {
                reportErrors.DirectReportDesignation = "Direct Report Designation is required.";
            }

            if (!report.DirectReportDepartment) {
                reportErrors.DirectReportDepartment = "Direct Report Department is required.";
            }

            if (Object.keys(reportErrors).length > 0) {
                errors[index] = reportErrors; // Store errors per report index
            }
        });

        return errors;
    };

    const handleReportInputChange = (index, e) => {
        const { name, value } = e.target;
        const updated = [...reportsData];

        if (name === "DirectReportName") {

            const emp = AllEmployees.find(
                (x) => `${x.firstname} ${x.lastname}` === value
            ) || {};
            updated[index] = {
                ...updated[index],
                DirectReportName: value,
                DirectReportDesignation: emp.designation || "",
                DirectReportDepartment: emp.department || "",
                reportingId: emp.id,
            };

        } else {
            updated[index] = { ...updated[index], [name]: value };
        }

        setReportsData(updated);
        const newErrors = validateReportField(updated);
        setDirectReportErrors(newErrors);

        const allValid = updated.every((rpt, i) => {
            const errs = newErrors[i] || {};
            return (
                rpt.DirectReportName?.trim() &&
                rpt.DirectReportType?.trim() &&
                rpt.DirectReportDesignation &&
                rpt.DirectReportDepartment &&
                Object.keys(errs).length === 0
            );
        });
        setIsDirectReportFormValid(allValid);
    };

    // Add New Direct Report Entry
    const addReport = () => {
        const newDirectReport = {
            DirectReportName: "",
            DirectReportType: "",
            DirectReportDesignation: "",
            DirectReportDepartment: "",
        };

        setReportsData((prev) => [...prev, newDirectReport]);
        setIsDirectReportFormValid(false);
    };
    // Delete Direct Report Entry
    const removeReport = (index) => {
        handleDeleteItem(index, reportsData, setReportsData, reportErrors, setDirectReportErrors, setIsDirectReportFormValid);
    };

    const handleReportSubmit = async (e) => {
        e.preventDefault();

        const newErrors = validateReportField(reportsData);
        setDirectReportErrors(newErrors);

        const noErrors = Object.keys(newErrors).length === 0;

        setIsDirectReportFormValid(noErrors);

        const sanitizedDirectReports = reportsData?.map(({ __typename, ...report }) => report);
        const input = { teamsReportDirect: sanitizedDirectReports };
        try {
            const val = await handleSubmit({
                noErrors,
                formValid: isDirectReportFormValid,
                dataObj: input,
                action: "ReportsHistory",
                ModalName: "handleReportSubmit",
                submitAction: "handleEducationSubmit",
            });
            if (val) {
                dispatch(setReportsDatas(sanitizedDirectReports));
                setIsDirectReportFormValid(false);
            }
        }
        catch (error) {
            console.error("handleSubmit error:", error);
            message.error({
                content: "Failed to update handleReportSubmit. Please try again.",
                duration: 5,
                className: "custom-toast-center",
            });
        } finally {
            setIsDirectReportFormValid(false);
        }
    };
    const names = AllEmployees
        .filter(item => item.employeestatus === "Active")
        .map((item, index) => ({
            key: index,
            label: `${item.firstname} ${item.lastname}`,
            value: `${item.firstname} ${item.lastname}`,
        }));

    useEffect(() => {
        setReportsData(Reportsup);
    }, [Reportsup])

    return (
        <>
            <Modal id="direct_reports"
                title="Direct Reports Information"
                handleSubmit={handleReportSubmit}
                isUserDataValid={false}
                handleModalClose={() =>
                    handleClose(Reportsup,
                        setReportsData,
                        setDirectReportErrors,
                        setIsDirectReportFormValid)} >
                <div className="form-scroll">
                    {reportsData?.map((report, index) => (
                        <div className="card" key={index}>
                            <div className="card-body">
                                <h3 className="card-title">
                                    Direct Report Information {index + 1}
                                    <Link to="#" className="delete-icon" onClick={() => removeReport(index)}>
                                        <i className="fa-regular fa-trash-can" />
                                    </Link>
                                </h3>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="input-block mb-2">
                                            <SelectInput
                                                label="Name"
                                                name="Name"
                                                value={report?.DirectReportName}
                                                onChange={(e, row) =>
                                                    handleReportInputChange(index, {
                                                        target: {
                                                            name: "DirectReportName",
                                                            value: e,

                                                        }
                                                    })
                                                }
                                                formControl={true}
                                                options={names.filter(
                                                    (n) =>
                                                        !reportsData.some((m, i) =>
                                                            i !== index && m.DirectReportName === n.value
                                                        )
                                                )}
                                                style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                                                error={reportErrors[index]?.DirectReportName}
                                            /> {/* Increased margin-bottom here */}

                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-block mb-2">

                                            <SelectInput
                                                label="Type"
                                                name="DirectReportType"
                                                value={report?.DirectReportType}
                                                onChange={(e) =>
                                                    handleReportInputChange(index, {
                                                        target: {
                                                            name: "DirectReportType",
                                                            value: e,
                                                        }
                                                    })
                                                }
                                                formControl={true}
                                                options={getOptionsByPath(NestedDatabucket, [DIRECT_REPORTS, TEAM_TYPE])}

                                                style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                                                error={reportErrors[index]?.DirectReportType}
                                            />


                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <SelectInput
                                            label="Department"
                                            name="DirectReportDepartment"
                                            value={report?.DirectReportDepartment}
                                            onChange={(value) => handleChange(value, 'reportingManagerDepartment', handleReportInputChange)}
                                            disabled={true}
                                            formControl={true}
                                            options={Departmentoptions}
                                            style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                                            error={reportErrors[index]?.DirectReportDepartment}

                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <SelectInput
                                            label="Designation"
                                            name="DirectReportDesignation"
                                            disabled={true}
                                            value={report?.DirectReportDesignation}
                                            onChange={(e) =>
                                                handleReportInputChange(index, {
                                                    target: {
                                                        name: "DirectReportDesignation",
                                                        value: e,
                                                    }
                                                })
                                            }
                                            formControl={true}
                                            options={getOptionsByPath(NestedDatabucket, [...[ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT], selectedId])}

                                            style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                                            error={reportErrors[index]?.DirectReportDesignation}

                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    <div className="add-more">
                        <Link to="#" onClick={addReport}>
                            <i className="fa-solid fa-plus-circle" /> Add More
                        </Link>
                    </div>
                </div>
            </Modal>
        </>
    )
}
